import React, { useRef, useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface ColumnChartProps {
  months: string[];   // X-axis labels
  sales: number[];     // Y-axis values
}

const SalesChart: React.FC<ColumnChartProps> = ({ months, sales }) => {
  const chartRef = useRef<HTMLDivElement | null>(null); 
  const [chartWidth, setChartWidth] = useState<number>(600);  // Default width
  const [chartHeight, setChartHeight] = useState<number>(250); // Default height
  const options: ApexOptions = {
    chart: {
      type: "bar",
      toolbar: { show: false }
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "45%",
        dataLabels: {
          position: "top" // TOP data labels
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => val.toString(),
      offsetY: -20,
      style: {
        fontSize: "14px",
        fontWeight: "bold"
      }
    },
    xaxis: {
      categories: months,
      // title: { text: "Months" },
      axisBorder: { show: false },
      axisTicks: { show: false }
    },
    yaxis: {
      // title: { text: "Sales" },
      labels: {
        formatter: (value) => value.toString()
      }
    },
    tooltip: {
      theme: "dark"
    }
  };

  const series = [
    {
      name: "Sales",
      data: sales
    }
  ];

  useEffect(() => {
    const updateDimensions = () => {
      if (chartRef.current) {
        setChartWidth(chartRef.current.offsetWidth); // Set width based on container size
        setChartHeight(chartRef.current.offsetHeight); // Set height based on container size
      }
    };

    // Update dimensions on resize
    window.addEventListener("resize", updateDimensions);

    // Set initial dimensions
    updateDimensions();

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", updateDimensions);
    };
  }, []);

  return <div ref={chartRef} style={{ width: "100%", height: "200px" }}>
          <Chart
            options={options}
            series={series}
            type="bar"
            width={chartWidth}
            height={chartHeight}
          />
        </div>;
};

export default SalesChart;
